import { createSelector } from "reselect";

const artisanCategoriesStateSelector = (state) => state.artisanJobCategories;
const selectById = (state, itemId) => itemId;

export const artisanCategoriesSelector = createSelector(
  [artisanCategoriesStateSelector],
  (artisanCategories) => artisanCategories.items
);

export const artisanCategoriesListSelector = createSelector(
  [artisanCategoriesSelector],
  (artisanCategory) =>
    artisanCategory.map(({ _id, name , namei18n, parentId}) => ({
      _id,
      name,
      parentId,
      namei18n
    }))
);

export const artisanCategoryByIdSelector = createSelector(
  [artisanCategoriesSelector, selectById],
  (artisanCategories, _id) => {
    const category = artisanCategories.find((item) => _id === item._id);
    if (!category) return null;
    return category;
  }
);

export const artisanCategoriesIsLoadingSelector = createSelector(
  [artisanCategoriesStateSelector],
  (artisanCategories) => artisanCategories.isLoading
);

export const artisanCategoriesAsLabelAndValueSelector = createSelector(
  [artisanCategoriesSelector],
  (artisanCategory) =>
    artisanCategory.map(({ _id, name }) => ({
      _id,
      name,
    }))
);

export const artisanCategoriesCountSelector = createSelector(
  [artisanCategoriesStateSelector],
  (artisanCategories) => artisanCategories.count
);

export const searchValueSelector = createSelector(
  [artisanCategoriesStateSelector],
  (artisanCategories) => artisanCategories.searchValue
);


export const artisanCategoriesAsValueAndLabel = createSelector(
  [artisanCategoriesSelector],
  (artisanCategory) =>
    artisanCategory.map(({ _id, name }) => ({
     value: _id,
     label: name,
    }))
);


export const artisanParentCategoriesSelector = createSelector(
  [artisanCategoriesStateSelector],
  (parent) => parent.parent
)


export const artisanParentCategoriesAsValueAndLabel = createSelector(
  [artisanParentCategoriesSelector],
  (artisanCategory) =>
    artisanCategory.map(({ _id, name }) => ({
   _id,
    name,
    }))
);
